<template>
  <div :class="styleClass">
    <v-layout
      row
      wrap
      align-end
      justify-space-between
      :class="`${color}--text text--${variant} px-5`"
    >
      <p class="pa-0 title font-weight-medium">{{ title }}</p>

      <v-layout
        d-flex
        row
        align-center
        justify-end
        style="max-width: fit-content"
      >
        <v-tooltip bottom>
          <v-select
            slot="activator"
            v-if="!hideSortOptions"
            v-model="sortItem"
            :items="sortOptions"
            label="Ordenar por"
            dense
            single-line
            :color="color + ' ' + variant"
            hide-details
            class="mr-2 mt-0 pt-0 mb-2"
            style="max-width: 220px"
            @change="$emit('sortChange', { sortItem, sortDir })"
          >
            <template #prepend-item>
              <small :class="`pl-2 ${color}--text text--${variant}`">
                Ordenar por:
              </small>
            </template>

            <template v-slot:item="{ item }">
              <v-icon
                v-if="seriesInfo[item.text]"
                small
                class="mr-2"
                :color="seriesInfo[item.text].color || ''"
              >
                {{ seriesInfo[item.text].icon || "" }}
              </v-icon>
              {{ item.text }}
            </template>
          </v-select>
          <span>Ordena o eixo X com base na métrica selecionada</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="!hideSortOptions"
              icon
              small
              flat
              v-bind="attrs"
              :color="color + ' ' + variant"
              v-on="on"
              :disabled="sortItem === null"
              class="mt-0 mr-2"
              @click="toggleSortDir()"
              style="max-width: fit-content"
            >
              <v-icon
                small
                :style="`transform: rotate(-90deg) scaleY(${
                  sortDir === 'asc' ? -1 : 1
                });`"
              >
                mdi-sort-variant
              </v-icon>
            </v-btn>
          </template>
          Crescente / Decrescente
        </v-tooltip>

        <v-switch
          style="max-width: fit-content"
          hide-details
          :color="color + ' ' + variant"
          class="mb-1 mr-2 mt-0 pa-0"
          label="Ver números"
          v-model="showNumbers"
          @change="$emit('showNumbers', showNumbers)"
        ></v-switch>

        <slot name="header"></slot>
      </v-layout>
    </v-layout>
    <v-divider
      :class="color + ' ' + variant"
      class="mt-1 mb-1 ml-3 mr-3"
    ></v-divider>

    <slot name="default"></slot>
  </div>
</template>

<script>
export default {
  name: "dashboard-graph-group",
  props: {
    title: {
      type: String,
      required: true,
    },
    /**
     * Valores de color e variant possíveis aqui: https://v15.vuetifyjs.com/en/framework/colors/
     */
    color: {
      type: String,
      required: false,
      default: "black",
    },
    variant: {
      type: String,
      default: "",
    },
    styleClass: {
      type: String,
      default: "",
    },
    hideSortOptions: {
      type: Boolean,
      default: false,
    },
    sortOptions: {
      type: Array,
      default: () => [],
    },
    barOptions: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      showNumbers: false,
      sortItem: 0,
      sortDir: "desc",
    };
  },
  computed: {
    seriesInfo() {
      const info = {};
      if (
        this.hideSortOptions ||
        !this.barOptions ||
        !this.barOptions.series ||
        !this.barOptions.series.length
      )
        return info;
      this.barOptions.series.forEach(
        (s) =>
          (info[s.name] = {
            color: s.color || "",
            icon: s.type === "bar" ? "mdi-square" : "mdi-chart-line-variant",
          }),
      );
      return info;
    },
  },
  methods: {
    toggleSortDir() {
      this.sortDir = this.sortDir === "desc" ? "asc" : "desc";
      this.$emit("sortChange", {
        sortItem: this.sortItem,
        sortDir: this.sortDir,
      });
    },

    setShowNumbers(value) {
      this.showNumbers = value;
    },
    setSortItem(value) {
      if (this.hideSortOptions) return;
      if (value || value === 0) {
        this.sortItem = value;
        return;
      }
      this.sortItem = this.sortOptions.length ? this.sortOptions[0].value : 0;
    },
    setSortDir(value) {
      if (this.hideSortOptions) return;
      this.sortDir = value;
    },
    getShowNumbers() {
      return this.showNumbers;
    },
    getSortItem() {
      return this.sortItem;
    },
    getSortDir() {
      return this.sortDir;
    },
  },
};
</script>
